var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('vHeader'),_c('div',{staticClass:"wrap"},[_vm._t("default")],2),_c('minicartRes')],1)}
var staticRenderFns = []

export { render, staticRenderFns }